import React from "react";
import "../styles/main.css";
 import home from "../images/home.jpg";
import Video from "../images/video.mp4";
import { Link } from "react-router-dom";

function main() {
  return (
    <div className="mainHome">
      <div className="main_upp">
        <div className="container">
          <div className="main_row">
            <div className="main__left">
              <h1>Professional services</h1>
              <p>
                Engineering digital solutions and services for startups and
                enterprises
              </p>
              <Link to="/contact">
                <button className="bouncy">Contact Us</button>
              </Link>
            </div>

            <div className="main__right">
              <img className="main_right-img" src={home} alt="IT Services" />
            </div>
          </div>
        </div>
      </div>

      <div className="main_bottom">
        <div className="c2">
          <div className="main_bottom-left">
            <h1>What We Provide</h1>
            <video className="about__video" controls>
              <source src={Video} type="video/ogg" />
              Your browser does not support the video.
            </video>
          </div>

          <div className="main_bottom-left">
            <h1>Why We</h1>
            <p>
              {" "}
              <span role="img" aria-labelledby="verify">
                ✅
              </span>{" "}
              Reasonable Price
            </p>
            <p>
              <span role="img" aria-labelledby="verify">
                ✅
              </span>{" "}
              Quickly Quality Service
            </p>
            <p>
              <span role="img" aria-labelledby="verify">
                ✅
              </span>
              Fully Supported community
            </p>
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default main;
